import { copyToClipboard } from '@/utils/clipboard'
import { createFileRoute, useSearch } from '@tanstack/react-router'
import { Toast, Button } from 'antd-mobile'

export const Route = createFileRoute('/guide')({
  component: RouteComponent,
})

function RouteComponent() {
    const { redirect }: { redirect?: string } = useSearch({ from: '/guide' })
    const href =window.location.origin+redirect||'/'
    const handleCopy = async () => {
      const ok = await copyToClipboard(href)
      Toast.show({
        content: ok ? '已复制链接，请到微信中粘贴并打开' : '复制失败，请手动复制地址栏链接',
        duration: ok ? 1500 : 2000,
      })
    }
    return (
      <div style={{ padding: 16 }}>
        <h3 style={{ margin: '8px 0 16px' }}>请使用微信浏览器打开</h3>
        <p style={{ color: '#666', lineHeight: 1.6 }}>
          该功能需在微信内使用。请点击下方按钮复制当前链接，打开微信后粘贴发送聊天，点击链接打开页面。
        </p>
        <div style={{ marginTop: 16 }}>
          <Button color="primary" onClick={handleCopy} block>
            复制当前链接
          </Button>
        </div>
      </div>
    )
}